import { render, staticRenderFns } from "./EditTruck.vue?vue&type=template&id=e73024d8&scoped=true"
import script from "./EditTruck.vue?vue&type=script&lang=js"
export * from "./EditTruck.vue?vue&type=script&lang=js"
import style0 from "./EditTruck.vue?vue&type=style&index=0&id=e73024d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73024d8",
  null
  
)

export default component.exports